/**
 * 預約相關 API（B 端）。
 *
 * 歷史上預約都是在元件裡直接 api.get('/api/business/bookings')，沒有封裝檔。
 * 這支先只收「不指定人員」的待指派流程 —— 新功能沒必要繼承舊的散裝寫法，
 * 但也不在這裡動既有呼叫，避免一次改動面過大。
 *
 * 權限：讀清單只要看得到預約即可；指派需要 assignment:manage（店主與店長）。
 * 刻意不叫 booking:assign —— 後端 hasPermission 會讓 booking:* 自動涵蓋所有
 * booking: 開頭的權限，而櫃台角色有 booking:*，那樣命名等於連櫃台一起開放。
 */
import api from '../utils/api'

/* ---------------------- 不指定人員：待指派 ---------------------- */

/**
 * 待指派的預約清單（只回今天以後的）。
 * @returns {Promise<{count: number, bookings: Array}>}
 */
export const fetchPendingAssignments = async () => {
  const res = await api.get('/api/business/bookings/pending-assignment')
  return res.data?.data || { count: 0, bookings: [] }
}

/**
 * 指派人員。
 * 後端會再確認這位設計師該時段真的有空 —— 從收單到指派中間，
 * 他可能已經被別的客人指名走了。
 */
export const assignBookingStylist = (bookingId, stylistId) =>
  api.put(`/api/business/bookings/${bookingId}/assign`, { stylistId })

/* ------------------------------ 錯誤訊息 ------------------------------ */

/** 把 API 錯誤轉成店家看得懂的話，不要把 axios 原文丟到畫面上 */
export const getAssignError = (error, fallback = '指派失敗') => {
  const message = error?.response?.data?.error || error?.response?.data?.message
  if (message) return message
  if (!error?.response) return '無法連線到伺服器，請確認網路狀態'
  switch (error.response.status) {
    case 401:
      return '登入已過期，請重新登入'
    case 403:
      return '只有店主與店長可以指派人員'
    case 404:
      return '找不到這筆預約，可能已被取消'
    default:
      return fallback
  }
}
